import { Q } from "@nozbe/watermelondb";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { compose } from "recompose";
import StockCount from "@/utilities/data/model/StockCount";
import { UseSortByResult } from "@/utilities/use-sort";
import {
  withCurrentCountContext,
  withStockCountScreenContext,
  withStockCountSearchContext,
  withStockCountSyncContext,
} from "../../enhancers";
import { SceneProps } from "../../types";
import { StockCountScene } from "../StockCountScene";
import { StockCountSyncContextType } from "@/utilities/stock-count";

const getObservables = ({
  stockCount,
  sortBy,
}: {
  stockCount: StockCount;
  sortBy: UseSortByResult<{
    expected?: undefined;
    counted?: undefined;
  }>;
}) => {
  const sortClause = sortBy.sortBy?.expected
    ? Q.sortBy("expected", sortBy.sortBy.expected)
    : sortBy.sortBy?.counted
    ? Q.sortBy("counted", sortBy.sortBy.counted)
    : Q.sortBy("updated_at", Q.desc);

  // query for list (limited)
  const itemsQuery = stockCount.items.extend(sortClause, Q.take(22));

  // query for count (no limit)
  const countQuery = stockCount.items;

  return {
    items: itemsQuery.observeWithColumns(["updated_at"]),
    totalItemsCount: countQuery.observeCount(),
  };
};

export type AllInventoryMovementItemsSceneRendererProps = SceneProps &
  StockCountSyncContextType &
  ExtractedObservables<ReturnType<typeof getObservables>> & {
    stockCount: StockCount;
  };

export const AllInventoryMovementItemsSceneRenderer = ({
  stockCount,
  items,
  ...props
}: AllInventoryMovementItemsSceneRendererProps) => {
  return <StockCountScene {...props} stockCount={stockCount} items={items} />;
};

export const AllInventoryMovementItemsScene = compose(
  withStockCountScreenContext,
  withStockCountSearchContext,
  withStockCountSyncContext,
  withCurrentCountContext,
  withObservables(["stockCount", "sortBy"], getObservables),
  //@ts-ignore
)(AllInventoryMovementItemsSceneRenderer);
